export const tailwindConfig = {
  fontFamily: {
    sans: ['Rubik', 'sans-serif'],
    montserrat: ['Montserrat', 'sans-serif'],
  },
  extend: {
    colors: {
      deepGreen: {
        50:  '#e6f5f0',
        100: '#c0e3d9',
        200: '#97cfbe',
        300: '#6dbba3',
        400: '#45a78b',
        500: '#0C5542',
        600: '#0a4536',
        700: '#083629',
        800: '#06251d',
        900: '#03140f',
        950: '#010a07',
      },
      leftArrow: '#0C5542',
    },
    fontSize: {
      '2xs': ['0.625rem', '0.75rem'],
    },
    height: {
      26: '6.5rem',
    },
    width: {
      26: '6.5rem'
    },
    minHeight: {
      18: '4.5rem',
    },
    borderWidth: {
      '1.5': '1.5px',
    },
  }
};